import { render, staticRenderFns } from "./GenerateCAV.vue?vue&type=template&id=06cdcde6"
import script from "./GenerateCAV.vue?vue&type=script&lang=js"
export * from "./GenerateCAV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports